import { Suspense } from "react";
import { useSearchParams } from "react-router-dom";
import { VehicleDetailsContent } from "../components";
import { useGetVehicleById } from "../query";

export default function VehicleDetailsPage() {
	const [searchParams] = useSearchParams();
	const vehicleId = searchParams.get("id") || "";

	const { data: vehicle, isLoading, isError } = useGetVehicleById(vehicleId);

	if (isError) {
		return (
			<Suspense fallback={<div>Loading...</div>}>
				<div className="flex min-h-screen items-center justify-center">
					<p className="text-red-500">
						Erro ao carregar detalhes do veículo. Tente novamente.
					</p>
				</div>
			</Suspense>
		);
	}

	return <VehicleDetailsContent isLoading={isLoading} vehicle={vehicle} />;
}
